import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { showNotification, Button } from "react-admin";
import { push } from "react-router-redux";
import UpIcon from "@material-ui/icons/ExpandLess";
import Tooltip from "@material-ui/core/Tooltip";

class UpButton extends Component {
    handleClick = () => {
        const { push, record, showNotification } = this.props;
        fetch(`${process.env.REACT_APP_API_URL}/pages/${record.id}/move/up`, {
            method: "PUT",
            headers: {
                accept: "application/json",
                "content-type": "application/json; charset=utf-8",
                authorization: `Bearer ${localStorage.token}`,
                "x-api-key": process.env.REACT_APP_API_KEY
            }
        })
            .then(() => {
                showNotification("Up Order Success");
                push("/pages");
            })
            .catch(e => {
                showNotification("Error: Up Order problem", "warning");
            });
    };

    render() {
        const {
            record: { Publish, Order }
        } = this.props;

        return (
            Publish === true &&
            Order !== 1 && (
                <Button onClick={this.handleClick}>
                    <Tooltip title="Up Order">
                        <UpIcon />
                    </Tooltip>
                </Button>
            )
        );
    }
}

UpButton.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func
};

export default connect(
    null,
    {
        showNotification,
        push
    }
)(UpButton);
